import axios from 'axios';
import { Message } from 'element-ui';
import qs from 'qs';
import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/index';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageLoadend: false,
    isAdmin: true,
    userInfo: null,
    //积分规则
    scoreMenuList: [],
    //字典
    dic: {
      schoolTerm: '', //学期
      positional: '', //职称
      dutuies: '', //职务
      education: '', //学历
    },
    teacherOptions: [], //下拉教师列表
    teacherLoading: false,
    ruleOptions: [],
    ruleOptionsList: [], //所有积分code
  },
  mutations: {
    loadingStart(state) {
      state.pageLoadend = false;
    },
    loadingFinish(state) {
      state.pageLoadend = true;
    },
    handleUserInfo(state, data) {
      state.userInfo = data;
      //教师
      if (data.roleCodes.indexOf('admin') === -1) {
        state.isAdmin = false;
      } else {
        state.isAdmin = true;
      }

      //积分菜单
      state.scoreMenuList = [];
      data.menuInfoList.forEach((item) => {
        //去掉 报表 系统 教案
        if (item.menuCode === 'statistics' || item.menuCode === 'system') {
          return;
        }
        if (item.menuInfoList && item.menuInfoList.length > 0) {
          item.menuInfoList.forEach((item2) => {
            if (item2.menuCode === 'lessonplan') {
              return;
            }
            state.scoreMenuList.push(item2);
          });
        } else {
          state.scoreMenuList.push(item);
        }
      });
    },
    //下拉教师列表
    handleTeacherOptions(state, data) {
      state.teacherOptions = data;
      state.teacherLoading = false;
    },
    startLeacherLoading(state) {
      state.teacherLoading = true;
    },
    //下拉规则列表
    handleRuleOptions(state, data) {
      // console.log("res", res);
      state.ruleOptions = [];
      state.ruleOptions = data;
      state.ruleOptionsList = [];
      if (data && data.length > 0) {
        this.commit('getRuleOptionsList', data);
      }
    },
    //递归 得到积分
    getRuleOptionsList(state, arr) {
      arr.forEach((item) => {
        if (item.integralCode) {
          state.ruleOptionsList.push(item.integralCode);
        }
        if (item.child && item.child.length > 0) {
          this.commit('getRuleOptionsList', item.child);
          return;
        }
      });
    },
    //字典
    //学期写死
    handleDicTerm(state) {
      state.dic.schoolTerm = [
        {
          dicCode: '1',
          dicName: '第一学期',
          dicType: 'schoolTerm',
          id: 91,
          typeName: '学期',
        },
        {
          dicCode: '2',
          dicName: '第二学期',
          dicType: 'schoolTerm',
          id: 92,
          typeName: '学期',
        },
      ];
    },
    handleDicPositional(state, data) {
      state.dic.positional = data;
    },
    handleDicDutuies(state, data) {
      state.dic.dutuies = data;
    },
    handleDicEducation(state, data) {
      state.dic.education = data;
    },
  },
  actions: {
    getUserInfo() {
      const paramsObj = {
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        userId: localStorage.getItem('userId'),
        clientVersion: '1.0',
        appType: 'pc',
        menuType: 'web',
      };
      return new Promise((resolve) => {
        axios
          .get('/user/getUserInfoById', { params: paramsObj })
          .then(({ data, resultCode, msg }) => {
            if (resultCode === 200) {
              this.commit('handleUserInfo', data);
            } else {
              Message({
                message: msg,
                type: 'error',
                duration: 2000,
              });
              router.push('/login');
            }
            resolve();
          });
      });
    },
    getDic() {
      // const paramsTermDic = {
      //   clientPackage: "com.xueduoduo.teacher.archives.pc",
      //   dicType: "schoolTerm",
      // }
      const paramsPositionalDic = {
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        dicType: 'academic_titles',
      };
      const paramsDutuiesDic = {
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        dicType: 'duties',
      };
      const paramsEducationDic = {
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        dicType: 'education_type',
      };
      return new Promise((resolve) => {
        // axios.get("/dic/listDictionaryByDicType", { params: paramsTermDic })
        //   .then((res) => {
        //     if (res.records && res.records.length > 0) {
        //       this.commit("handleDicTerm", res.records);
        //     }
        //     resolve()
        //   });
        axios
          .get('/dic/listDictionaryByDicType', { params: paramsPositionalDic })
          .then((res) => {
            if (res.data.records && res.data.records.length > 0) {
              this.commit('handleDicPositional', res.data.records);
              this.commit('handleDicTerm'); //处理学期
            }
            resolve();
          });
        axios
          .get('/dic/listDictionaryByDicType', { params: paramsDutuiesDic })
          .then((res) => {
            if (res.data.records && res.data.records.length > 0) {
              this.commit('handleDicDutuies', res.data.records);
            }
            resolve();
          });
        axios
          .get('/dic/listDictionaryByDicType', { params: paramsEducationDic })
          .then((res) => {
            if (res.data.records && res.data.records.length > 0) {
              this.commit('handleDicEducation', res.data.records);
            } else {
              Message({
                message: '数据字典获取错误',
                type: 'error',
                duration: 2000,
              });
            }
            resolve();
          });
      });
    },
    //根据关键字查询教师列表
    getTeacherOptions({ commit, state }, keyword) {
      commit('startLeacherLoading');
      //查询教师 ,教师角色只能查询到自己的
      let teacherForm = {
        schoolCode: state.isAdmin ? '' : state.userInfo.schoolCode, //管理员查询集团校下所有教师
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        userName: state.isAdmin ? keyword : '',
        pageNum: 1,
        pageSize: -1,
        userId: state.isAdmin ? '' : state.userInfo.userId,
      };
      axios
        .post('/user/getUserArchivesList', teacherForm)
        .then((res) => {
          if (res.data.records && res.data.records.length > 0) {
            commit('handleTeacherOptions', res.data.records);
          }
        })
        .catch((err) => {
          Message({
            message: '教师列表获取错误',
            type: 'error',
            duration: 2000,
          });
        });
    },
    //查询积分查询 下拉框选择积分项
    getRuleOptions({ commit, state }, menuCode) {
      let selectForm = {
        integralModel: menuCode,
        schoolCode: state.userInfo.schoolCode,
        clientPackage: 'com.xueduoduo.teacher.archives.pc',
        havaChild:
          menuCode === 'paper_ssdt' ||
          menuCode === 'curriculum_ssdt' ||
          menuCode === 'case-lesson'
            ? 0
            : 1,
      };
      axios
        .post('/integralRule/getTeacherIntegralRule', qs.stringify(selectForm))
        .then((res) => {
          if (res.resultCode === 200) {
            commit('handleRuleOptions', res.data.child);
          } else {
            console.log('查询积分规则else', res);
          }
        })
        .catch((err) => {
          console.log('查询积分规则error', err);
        });
    },
  },
});
